import apiUrl from '../../../constants'
import axios from 'axios'

import {
  Validator
} from 'vee-validate'
import {
  BasicSelect
} from 'vue-search-select'
import moment from 'moment'
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';

export default {
  name: 'hub-details',
  components: {
    BasicSelect,
    VueElementLoading
  },
  props: [],
  data() {
    return {
      isLoading: false,
      PortList: '',
      portlist: [],
      WeightDetails: [],
      portitem: {
        id: '',
        text: ''
      },
      HubId: '',
      machineId: '',
      locationName: '',
      weighttype: '',
      length: '',
      breadth: '',
      height: '',
      physicalweight: '',
      shipmentid: '',
      displayShipmentid: '',
      confirmwt: false,
      confirmvolwt:false,
      Destination: '',
      ProcessCode: '',
      ZoneName: '',
      fullSuccessMessage: '',
      disabledLength: 1,
      disabledBreadth: 1,
      disabledHeight: 1,
      disabledPhysicalWeight: 1,
      ConfirmPhysicalWeight: false,
      ConfirmVolumetricWeight:false,
      IsHeavyShipment:false,
      mpsType : '',
      inscanShipmentid:'',
      token: '',
      invalidTokenModal: false,
      invalidtokenmsg: '',
      timeoutHandler: 0,
			inputString:'',
			manualInput:false,
      machineError:false,
      locationError:false,
      machineErrorMsg:'',
      locationErrorMsg:'',
      MOT:'',
      ShipmentType:''
    }
  },
  computed: {},
  mounted() {
    var userTokenEncrypt = window.localStorage.getItem('userToken')
    var userTokenDecrypt = CryptoJS.AES.decrypt(userTokenEncrypt.toString(), 'Key');
    var userToken = userTokenDecrypt.toString(CryptoJS.enc.Utf8);
    this.token = JSON.parse(userToken)
    var userdetailEncrypt = window.localStorage.getItem('userdetail')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext)
    this.warehouseid = userdetail[0].warehouseid;
    this.createdBy = userdetail[0].email;
    this.HubId = userdetail[0].HubId[0];
    // this.getPortList()

  },
  methods: {
    checkBarcode(e){
			if (this.timeoutHandler) {
      clearTimeout(this.timeoutHandler)
      this.inputString += String.fromCharCode(e.keyCode)
    	}
			this.timeoutHandler = setTimeout(() => {
		 		if (this.inputString.length <= 3) {
			 		this.manualInput = true
			 		this.inputString = ''
		 		}else{
			 		this.manualInput = false
			 		this.inputString = ''
		 		}
	 		}, 10)
 		},
    // selectPort(portitem) {
    //   this.portitem = portitem
    //   this.portitem.text = this.machineId
    // },
    // getPortList() {
    //   axios({
    //       method: 'GET',
    //       'url': 'http://localhost:8081/api/portlist'
    //     })
    //     .then(result => {
    //       // var comArr = [{"comName":"/dev/ttyS0"},{"comName":"/dev/ttyS1"},{"comName":"/dev/ttyS10"},{"comName":"/dev/ttyS11"},{"comName":"/dev/ttyS12"},{"comName":"/dev/ttyS13"},{"comName":"/dev/ttyS14"},{"comName":"/dev/ttyS15"},{"comName":"/dev/ttyS16"},{"comName":"/dev/ttyS17"},{"comName":"/dev/ttyS18"},{"comName":"/dev/ttyS19"},{"comName":"/dev/ttyS2"},{"comName":"/dev/ttyS20"},{"comName":"/dev/ttyS21"},{"comName":"/dev/ttyS22"},{"comName":"/dev/ttyS23"},{"comName":"/dev/ttyS24"},{"comName":"/dev/ttyS25"},{"comName":"/dev/ttyS26"},{"comName":"/dev/ttyS27"},{"comName":"/dev/ttyS28"},{"comName":"/dev/ttyS29"},{"comName":"/dev/ttyS3"},{"comName":"/dev/ttyS30"},{"comName":"/dev/ttyS31"},{"comName":"/dev/ttyS4"},{"comName":"/dev/ttyS5"},{"comName":"/dev/ttyS6"},{"comName":"/dev/ttyS7"},{"comName":"/dev/ttyS8"},{"comName":"/dev/ttyS9"},{"comName":"/dev/ttyUSB0","manufacturer":"FTDI","serialNumber":"FTDI_Chipi-X_FT0DI38A","pnpId":"usb-FTDI_Chipi-X_FT0DI38A-if00-port0","vendorId":"0x0403","productId":"0x6015"}];
    //
    //       var comArr = result.data;
    //       this.portlist = comArr.filter(res => {
    //         let manufacturer='';
    //         if(res.manufacturer)
    //         {
    //           manufacturer=res.manufacturer.toLowerCase();
    //         }
    //         if(res.manufacturer == 'FTDI' || res.manufacturer == 'Megawin_Technology_Co.__Ltd.' || manufacturer.includes('prolific') || manufacturer.includes('cadyce')){
    //           return res.manufacturer
    //         }
    //       })
    //
    //       // var portlst = '';
    //       // var result2 = {
    //       //   "returnCode": "100",
    //       //   "returnMessage": "successful",
    //       //   "comName": "/dev/ttyUSB0"
    //       // }
    //       // var result1 = [result]
    //       // for (var i = 0; i < result1.length; i++) {
    //       //   portlst = result1[i].comName.match(/\//);
    //       // }
    //       // this.PortList = result1.comName;
    //       // console.log(portlst.input);
    //       // this.PortList = [{
    //       //   'machineId': portlst.input
    //       // }]
    //       //    if (result.data.returnCode == 100) {
    //       // this.PortList = result.data.comName;
    //       //    } else {
    //       //  this.$alertify.error(result.data.returnMessage)
    //       //    }
    //     }, error => {
    //       console.error(error)
    //       if (error.response == undefined) {
    //         this.$alertify.error('DWS machine not connected')
    //       }
    //     })
    // },
    calculateWeight() {

      this.input = ({
        "MID": this.machineId,
        "LOCATION": this.locationName
      })
      axios({
          method: 'POST',
          'url': 'http://localhost:9001/getdetails',
          'data': this.input

        })
        .then(result => {
          console.log(result.data,"result.data");
          //  if (result.data.returnCode == 100) {
          if(result)
          {
            this.WeightDetails = result.data;

            this.physicalweight = this.WeightDetails.Shipmentweight
            this.length = this.WeightDetails.ShipmentLength
            this.breadth = this.WeightDetails.ShipmentBreadth
            this.height = this.WeightDetails.ShipmentHeight
            console.log(this.WeightDetails,"this.WeightDetails",this.physicalweight,"this.physicalweight",
            this.length,"this.length",this.height,"this.height");
            this.inscan();
          }

        }, error => {
          if (error.response == undefined) {
            this.$alertify.error('DWS machine not connected')
          }
          console.error(error)
        })
    },
    logout(e) {
      localStorage.removeItem('permissiondata')
      localStorage.removeItem('userdetail')
      localStorage.removeItem('userToken')
      localStorage.removeItem('isLoggedIn')
      localStorage.removeItem('loginDate')
      this.$router.push('/login')
      e.preventDefault()
    },
    closeinvalidTokenModal() {
      this.invalidTokenModal = false
      this.invalidtokenmsg = ''
    },
    inscan() {
      if (this.physicalweight <= 0) {
        this.$alertify.error("Physical weight cannot be blank or zero")
        return false;
      }
      if (this.physicalweight > 20) {
        this.confirmwt = true
        this.ConfirmPhysicalWeight = true
        this.$alertify.error("Physical Weight is more than 20 KG")
      } else {
        this.confirmwt = false
      }
      this.VolumetricWeight = (this.length * this.breadth * this.height) / 6000;
      if (this.VolumetricWeight > 20) {
        this.confirmvolwt = true
        this.ConfirmVolumetricWeight = true
        this.$alertify.error("Volumetric Weight is more than 20 KG")
      } else {
        this.confirmvolwt = false
      }
      this.input = ({
        "shippingID": this.shipmentid,
        "originHubID": this.HubId,
        "lastModifiedBy": this.createdBy,
        "physicalWeight": this.physicalweight,
        "shipmentLength": this.length,
        "shipmentBreadth": this.breadth,
        "shipmentHeight": this.height,
        "inScanFromDevice": this.weighttype,
        "isConfirmInScan": true,
        "isConfirmVolWt": this.ConfirmVolumetricWeight,
        "isConfirmPhyWt": this.ConfirmPhysicalWeight,
        "latitude": 0,
        "longitude": 0,
        "deviceID": null,
        "deviceCapturedDate": null,
        "statusMarkedFrom": "UA",
        "shipmentImageUrl": "",
        "inscanType": 3,
        "isManualEntry": this.manualInput
      })
      console.log(this.input,"this.input");
      axios({
          method: 'POST',
          'url': apiUrl.api_url_hubops + 'manualShipmentInScan',
          'data': this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
            'requestfrom': "WEB",
            'token': this.token
          }
        })
        .then((result) => {
            if (result.data.ResultCode == 100) {
              this.invalidTokenModal = false
              this.inscanShipmentid = this.shipmentid;
              this.shipmentid = ''
              this.manualInput = false
              this.$validator.reset()
              this.$alertify.success(result.data.ReturnMessage)
              this.getHubCode()
            } else if (result.data.ResultCode == 103) {
              this.invalidTokenModal = false
              this.$alertify.error(result.data.ReturnMessage)
              this.shipmentid = '';
              this.manualInput = false
              this.fullSuccessMessage = '';
              this.Destination = '';
              this.ProcessCode = '';
              this.ZoneName = '';
              this.$validator.reset()
            } else if (result.data.ResultCode == 401) {
              this.invalidTokenModal = true
              this.invalidtokenmsg = result.data.ReturnMessage
              this.$alertify.error(result.data.ReturnMessage)
            } else {
              this.invalidTokenModal = false
              this.$alertify.error(result.data.ReturnMessage)
              this.shipmentid = '';
              this.manualInput = false
              this.fullSuccessMessage = '';
              this.Destination = '';
              this.ProcessCode = '';
              this.ZoneName = '';
              this.displayShipmentid = '';
              this.inscanShipmentid = '';
              this.$validator.reset()
            }
          },
          error => {
            console.error(error)
          }
        )
    },
    getHubCode() {
      this.fullSuccessMessage = '';
      this.isLoading = true;
      this.MOT = '';
      this.ShipmentType = '';
      axios({
          method: 'GET',
          'url': apiUrl.api_url_hubops + "getHubColourCode?shippingID=" + this.inscanShipmentid,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
            'requestfrom': "WEB",
            'token': this.token
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.invalidTokenModal = false
            this.isLoading = false;
            this.fullSuccessMessage = '1'
            this.IsHeavyShipment = result.data.isHeavyShipment
            this.mpsType = result.data.ResponseData.mpsType
            this.displayShipmentid = result.data.ResponseData.shippingId
            this.Destination = result.data.ResponseData.HubName
            this.ProcessCode = result.data.ResponseData.ProcessCode
            this.ZoneName = result.data.ResponseData.ZoneName
            this.MOT = result.data.ResponseData.MOT;
            this.ShipmentType = result.data.ResponseData.ShipmentType;
            // this.$alertify.success(result.data.ReturnMessage)
          } else if (result.data.ResultCode == 401) {
            this.invalidTokenModal = true
            this.IsHeavyShipment = false
            this.mpsType = ''
            this.invalidtokenmsg = result.data.ReturnMessage
            this.$alertify.error(result.data.ReturnMessage)
          } else {
            this.invalidTokenModal = false
            this.IsHeavyShipment = false
            this.mpsType = ''
            this.isLoading = false;
            this.fullSuccessMessage = ''
            this.Destination = ''
            this.ProcessCode = ''
            this.ZoneName = ''
            this.$alertify.error(result.data.ReturnMessage)
          }
        }, error => {
          this.isLoading = false;
          this.$alertify.error("Error at getHubColourCode API")
          console.error(error)
        })
    },
    resetForm() {
      this.machineError=false
      this.machineErrorMsg=""
      this.locationError=false
      this.locationErrorMsg=""
      this.weighttype = ''
      this.length = ''
      this.breadth = ''
      this.height = ''
      this.physicalweight = ''
      this.IsHeavyShipment = false
      this.mpsType = ''
      this.ConfirmPhysicalWeight = false
      this.ConfirmVolumetricWeight = false
      this.confirmwt = false
      this.confirmvolwt = false
      this.displayShipmentid=''
      this.inscanShipmentid = ''
      this.$validator.reset()
    },
    cancelID() {
      this.portitem = {
        id: '',
        text: ''
      }
      this.machineId = ''
      this.locationName = ''
      this.weighttype = ''
      this.length = ''
      this.breadth = ''
      this.height = ''
      this.physicalweight = ''
      this.shipmentid = ''
      this.manualInput = false
      this.confirmwt = false
      this.IsHeavyShipment = false
      this.mpsType = ''
      this.fullSuccessMessage = ''
      this.ConfirmPhysicalWeight = false
      this.ConfirmVolumetricWeight = false
      this.confirmwt = false
      this.confirmvolwt = false
      this.displayShipmentid=''
      this.inscanShipmentid = ''
      this.$validator.reset()
    },
    //validate all form fields on onsubmit()
    onSubmit: function() {
      this.$validator.validateAll().then((result) => {
        if (!result) {
          return false;
        }
      }).catch(() => {
        console.log('errors exist')
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/components/DWSInscanNew/DWSInscanNew.component.js